/* eslint-disable no-debugger */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */

import React, { useState,useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import BackButton from "../../components/BackButton/BackButton";
import styles from "./AccessControlPrivilage.module.css";
import { CustomTab, Button } from "../../atomicComponents";
import UserInfo from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import {
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField
} from "../../components/FormComponents";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import MultiSelect from "../../components/FormComponents/MultiSelect";
import MultiSelects from "../../components/FormComponents/MultiSelects";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import {
  MESSAGE_TYPE,
} from "../../constants";
import { setLogin } from '../../redux/features/auth/actions';
import Truckloading from "../../components/CvLoader/Cvloader";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";

function AccessControlTest({ baseUrl,
  auth,}) {
  const history = useHistory();
  const redirectToProcessPage = () => {
    history.push("/home");
  };
  const dispatchNew = useDispatch();


  const [roleList, setRoleList] = useState([
  ]);
  const [projectList,setProjectList]=useState([]);
  const [location, setLocation] = useState([]);
  const { showPopup } = usePopupManager();
  const [Bcs,setBcs]=useState([])
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedProject, setSelectedProject] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedBc, setSelectedBc] = useState([]);
  const [eventDetails,setEventDetails] = useState()
  const [state, setState] = React.useState({
    linkageFlag: false,
    bcFlag:false,
    locationFlag:false,
    persNo: ""
  });
  const [showTicketDetails,setShowTicketDetails]=useState(false);
  const [empDetails,setEmpDetails] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const debounceSerch = useDebounceSearch(state?.persNo)
  const getEmployeeDetails = (data) => {
    setLoading(true)
    try{
      
      let blankArray=[]
      let apiFormatedData={}
      if(data==undefined){
        apiFormatedData =
        {
          "i_pers_no":sanitizeNumeric(state.persNo),
          "location": blankArray
      }
      }
      else{
        let newData=data?.map((data)=>data.value)
        apiFormatedData ={
          "i_pers_no":sanitizeNumeric(state.persNo),
          "location":newData
        } 
        }
      
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      let headerss = new Headers();
      headerss.append('Content-Type', 'application/json');
      fetch(`${baseUrl}master/accesscontrolprivilegedisplay`,
        {
          method: 'POST',
          headers: headerss,
          body: apiFormatedDataJson,
          credentials:'include'
        }).then((response) => {
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          let lowercaseMsg = responseJson.msg.toLowerCase();
         
          if (lowercaseMsg==="success") {
            setLoading(false);

            if (responseJson.data["pers_data"][0]===undefined)
              {
                showPopup({
                  type: MESSAGE_TYPE.FAILURE,
                  contextText: MESSAGE_TYPE.FAILURE,
                  info: "Please enter valid Person number",
                  reloads:true,
                });
              }
              setEmpDetails(responseJson.data["pers_data"][0])  
             
              if(responseJson.data["pers_data"][0].complete_name !==""){
                setShowTicketDetails(true)
               
                let transformedData=responseJson.data.role_list?.map((item)=>({
                  label: item.code_desc,
                  value: item.code_code,
                }))
                let transformedDataProject=responseJson.data.project_details?.map((item)=>({
                  label: item.project,
                  value: item.project_def,
                }))
                let transformedDataBcs=responseJson.data.bc_details?.map(({complete_bc,bc_number})=>({
                  label: complete_bc,
                  value: bc_number,
                }))
                setBcs(transformedDataBcs)
                setRoleList(transformedData)
                setProjectList(transformedDataProject)
                setLocation( [{ value: "PUNE", label: "PUNE" },
                { value: "JAMSHEDPUR", label: "JAMSHEDPUR" },
                { value: "LUCKNOW", label: "LUCKNOW" }])
              }  
            }
            else if(lowercaseMsg==="fail"){
              setLoading(false);
                  showPopup({
                    type: responseJson.msg,
                    contextText: responseJson.msg,
                    info: responseJson.data,
                    reloads: false,
                  });
              }
        })
    }
    catch(error){
      setLoading(false);
      // console.info(error)
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Oops! Something went wrong. Please try again later",
        reloads:true,
      });
    }

   
  }
 
  useEffect(() => {
    if (debounceSerch){
            getEmployeeDetails()
        }  
        else{
        setEmpDetails([]);    
        setLocation([]);
        setSelectedBc([]);
        setSelectedRole("");
        setShowTicketDetails(false);
         setState((prev)=>({
          ...prev,
          linkageFlag:false,
          bcFlag:false,
          locationFlag:false,
          persNo:""
         }))

        } 
  }, [debounceSerch])
 
  const handleSave = async() => {
    setLoading(true);
    try {
      let apiFormatedData = {
        i_pers_no: sanitizeNumeric(state.persNo),
        i_role: selectedRole.value,
        i_location:selectedLocation ? selectedLocation?.map((data)=>data.value).join(",") :"",
        i_bc_no: selectedBc ? selectedBc?.map((data)=>data.value).join(",") :"",
        i_project_def:  selectedProject ? selectedProject?.map((data)=>data.value).join(",") :"",
        i_co_code: sanitizeCoCodeNumeric(auth.companyCode),
        i_pers_area: auth.persArea,
        i_user_id: auth.personNumber    
      }; 
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      let headerss = new Headers();
      headerss.append("Content-Type", "application/json");       
      const response = await fetch(`${baseUrl}master/accessprivilageSave`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      });
      dispatchNew(setLogin({...auth, recentStatus: response.status}))
      const responseJson = await response.json();
      let lowercaseMsg = responseJson.msg.toLowerCase();
      let res = responseJson;
      if(lowercaseMsg === "success"){
        setLoading(false);
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: res.data,
          reloads: true
        });
      } 
      if(lowercaseMsg === "fail"){
        setLoading(false);
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: res.data,
          reloads:true, // Set reload to true or false based on your condition
        });
      } 
       else {
        setLoading(false);
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: res.data,
          reloads:true,
        })}
   
    } catch (error) {
      setLoading(false);
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Oops! Something went wrong. Please try again later",
        reloads:true,
      });
      console.log(error);
    }
  };

  const handleKeyPress = (event) => {      
    const keyCode = event.charCode;
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  };

  const onChangeInput=(event)=>{  
    const {name,value}=event.target;

    setState((prevData)=>({
      ...prevData,
      [name]:value.trim()
    }))
  }

  const handleReset=()=>{
    setState((prevData)=>({
      ...prevData,
      linkageFlag:false,
      bcFlag:false,
      locationFlag:false,
      persNo:"",
      projectName:""
    }))
    setShowTicketDetails(false)
    setSelectedLocation([]);
    setSelectedRole("");
    setSelectedBc([])
    setEmpDetails([])

  }

  const renderHTML = () => (
    <>
    <div className={styles.formGroup}>
    <Grid
      container
      spacing={1}
      style={{ marginTop: "10px" }}
      columns={12}
    >
      <Grid item md={2} lg={2} xs={2} sm={2}>
        <div className={styles.rowDiv}>
          <div className={styles.lableDiv2}>
            <label>Employee Details </label>
          </div>
        </div>
      </Grid>
      <Grid item md={5} lg={5} xs={5} sm={10}>
        <TableSimple
          tableColumnData={[
            {
              ticket: (
                <ValidatingTextField
                variant="outlined"
                size="small"
                name="persNo"
                isDisabled={false}
                inputProps={{
                  "data-testid": "remark-input"
                }}
                onChange={onChangeInput}
                onKeyPress={(e)=>{
                  setEventDetails(e)
                  handleKeyPress        
                }}
                style={{ width: "100%" }}
              />
              ),
              empName:empDetails?.complete_name,
              costCentre:empDetails?.cost_center
    
            },
          ]}
          tableHeaderLabel={[
            "Person No_35",
            "Employee Name_60",
            "Cost Centre_40",
          ]}
          TableRowHederAling="start"
          size="small"
          headerColor="#E6F2FF"
          className="custom-table"
        />
      </Grid>
    </Grid>
  </div>
    </>

  );

  const handleRole = (selected) => {
    setSelectedRole(selected);
    if (selected?.value === "LI") {
      setState((prevData) => ({
        ...prevData,
        linkageFlag: true,
        bcFlag:true,
        locationFlag:true,
      }));
    } 
    else if(selected?.value==="B"){
      setState((prevData) => ({
        ...prevData,
        bcFlag:true,
        locationFlag:true,
        linkageFlag: false,
      }));
    }  
    else if(selected?.value==="DS"){
      setState((prevData) => ({
        ...prevData,
        bcFlag:true,
        locationFlag:true,
        linkageFlag: false,
      }));
    } 
    else {
      setState((prevData) => ({
        ...prevData,
        linkageFlag: false,
        bcFlag:false,
        locationFlag:false,
      }));
    }
  };

  const handleProject=(selected)=>{
    setSelectedProject(selected)
  }

  const renderRole = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid md={2} lg={2} sm={12}>
        <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
            <span style={{marginLeft:"10px"}}>Select Role</span>
            </div>
            </div>
        </Grid>

        <Grid item md={4} lg={4} sm={12}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <CustomSelect
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={roleList}
                name="role"
                value={selectedRole}
                onChange={handleRole}
              />
            </div>
          </div>
        </Grid>
        {state.bcFlag && state.locationFlag && (
        <>
        <Grid md={2} lg={2}>
        <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span style={{marginLeft:"10px"}}>Select Location</span>
            </div>
            </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <MultiSelect
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={location}
                name="location"
                value={selectedLocation}
                onChange={handleLocation}
              />
            </div>
          </div>
        </Grid>
        </>
       )}
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
      {state.bcFlag && state.locationFlag && (
        <>
        <Grid md={2} lg={2}>
        <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
            <span style={{marginLeft:"10px"}}> BC  Number</span>
            </div>
            </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <MultiSelects
               isMandatory
               className={clsx(styles.select, styles.sel2)}
               isClearable
               options={Bcs}
               name="role"
               value={selectedBc}
               onChange={handleBcdata}
             
             />  
            </div>
          </div>
        </Grid>
        </>
       )}
        {state.linkageFlag === true && (
          <>
              <Grid md={2} lg={2} sm={12}>
            <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
            <span style={{marginLeft:"10px"}}>Project</span>
            </div>
            </div>
        </Grid>
        <Grid item md={4} lg={4} sm={12}>
        <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <MultiSelects
                isMulti
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={projectList}
                name="project"
                value={selectedProject}
                onChange={handleProject}
              />
            </div>
          </div>
        </Grid>
          </>
         )}
     
        <Grid item md={6} lg={12} sm={12} style={{marginTop:"10px"}}>
          <div className={styles.rowDivButton}>
            <Button
              className={clsx(styles.actionButton, styles.primaryActionButton)}
              variant="primary"
              onClick={() => handleSave()}
              data-testid="confirm-action"
             
            >
              Save
            </Button>
            <Button
              className={clsx(styles.actionButton, styles.resetButton)}
              variant="tertiary"      
              onClick={handleReset}
            >
              Cancel
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );

const handleLocation=(selected)=>{
 setSelectedLocation(selected)
 getEmployeeDetails(selected) 
  }

  const handleBcdata=(selected)=>{
    setSelectedBc(selected)
  }

  const handleOk = () => {
    window.location.reload();
  } 

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton action="Home" handleClick={redirectToProcessPage} />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab
              title="Access Management"
              withOutCount
              isSelected
            />
          </div>
          <div className={styles.processTopbar} style={{}}>
            <UserInfo
              userInfo={[
                {
                  Name: "Priya Kumari",
                  "SAP ID": 122367,
                  "BC No": "122366",
                  LOC: "Engineering and Research Center"
                }
              ]}
            />
          </div>
        </div>
        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
          style={{ height: "82vh" }}
        >
          <CustomFormGroup
            header="Access & Role Control"
            body={renderHTML()}
          />
         
         
          {showTicketDetails && renderRole()}
          {loading==true ?
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"10px",background:"white", boxShadow:"0px 3px 6px #00000027"}}>
               <Truckloading />
            </div>
     : ""}       
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => ({
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({});
AccessControlTest.propTypes = {
  product: PropTypes.object
};
export default connect(mapStateToProps, mapDispatchToProps)(AccessControlTest);